module.exports = __webpack_public_path__ + "static/media/news-ellis_mental_health.590099bb.jpg";